import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[500px] md:h-[620px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20background%20with%20warm%20golden%20spotlight%20beams%2C%20elegant%20red%20velvet%20curtains%2C%20film%20reel%20elements%2C%20atmospheric%20dramatic%20lighting%2C%20luxurious%20cinema%20interior%20vibe%2C%20deep%20shadows%20with%20warm%20highlights&width=1920&height=800&seq=hero-cinema-bg&orientation=landscape"
        alt="6080影院 - 电影大全背景"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-accent-500/20 border border-accent-500/30 rounded-full mb-6">
              <i className="ri-sparkling-line text-accent-400 text-sm"></i>
              <span className="text-xs text-foreground-100 whitespace-nowrap">不缓冲播放 · 高清在线 · 完全免费</span>
            </div>
            <h1 className="text-3xl md:text-5xl font-bold text-foreground-50 leading-tight mb-4 font-heading">
              6080影院 · 电影大全
            </h1>
            <p className="text-base md:text-lg text-foreground-200 leading-relaxed mb-8 max-w-lg">
              最新电影、经典电影、动作电影、喜剧电影全覆盖，高清免费在线随时点播，打造极致观影体验。
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
              <Link
                to="/category/latest"
                className="px-6 py-3 bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 transition-colors text-sm font-medium whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line mr-2"></i>
                最新电影
              </Link>
              <Link
                to="/category/classic"
                className="px-6 py-3 bg-background-50/10 border border-foreground-200/20 text-foreground-100 rounded-md hover:bg-background-50/20 transition-colors text-sm whitespace-nowrap cursor-pointer"
              >
                <i className="ri-trophy-line mr-2"></i>
                经典电影
              </Link>
            </div>
            <div className="flex items-center gap-6 mt-10">
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-bold text-primary-400 font-heading">50,000+</p>
                <p className="text-xs text-foreground-300 mt-1">影片总数</p>
              </div>
              <div className="w-px h-10 bg-foreground-200/20"></div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">20+</p>
                <p className="text-xs text-foreground-300 mt-1">电影分类</p>
              </div>
              <div className="w-px h-10 bg-foreground-200/20"></div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-bold text-primary-400 font-heading">100万+</p>
                <p className="text-xs text-foreground-300 mt-1">日活用户</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}